<template>
  <div class="market-product-section">
    <!-- type: 1-理财产品 2-其它产品 3-实物产品 4-基金  -->
    <div v-if="(item.type === 2 && item.version !== 1) || item.type === 3" class="product-card-cloumn">
      <div class="product-card-cloumn-left">
        <div class="product-title text-ellipsis-line-2">
          <span v-if="item.hotPush" class="market-top-tag">推荐</span>
          {{ item?.title || item?.name || item?.fundName }}
        </div>
        <!-- 产品代码+分类 -->
        <!-- <div class="product-code-type">
          <span v-if="item.code" class="product-code text-ellipsis">{{ item.code }}</span>
          <span v-if="item.category && firstSelectItem?.id === 1" class="product-type text-ellipsis">{{
            item.category
          }}</span>
        </div> -->
        <!-- 产品特点 -->
        <div v-if="item.feature" class="feature text-ellipsis">{{ item.feature }}</div>
      </div>
      <img :src="item?.thumbNailPicUrl" v-if="item?.thumbNailPicUrl" class="product-card-cloumn-right" />
      <div v-else :class="`product-card-piccont ${item.type === 2 ? 'other' : 'material'} text-ellipsis`">
        {{ item.category }}
      </div>
    </div>
    <div v-else>
      <!-- 产品名称 -->
      <div class="product-title text-ellipsis-line-2">
        <span v-if="item.hotPush" class="market-top-tag">推荐</span>
        {{ item?.title || item?.name || item?.fundName }}
      </div>
      <!-- 产品代码+分类 -->
      <div class="product-code-type" v-if="(item.type === 2 && item.version === 1) || item.type === 4">
        <span v-if="item.code" class="product-code text-ellipsis">{{ item.code }}</span>
        <!-- <span v-if="item.category && firstSelectItem?.id === 1" class="product-type text-ellipsis">{{
          item.category
        }}</span> -->
        <span v-if="item?.fundProductSimpleInfo?.fundType" class="product-type text-ellipsis">{{
          item?.fundProductSimpleInfo?.fundType
        }}</span>
        <span v-if="item?.risk" class="product-type text-ellipsis">{{ item?.risk }}</span>
      </div>
      <!-- 基金类产品且有收益率|有价格|收益率是中文描述时有值 才展示利率和投资期限 -->
      <div v-if="isShowTimeHorizon(item)" class="product-detail-box">
        <div class="product-rate">
          <!--  理财类产品 -->
          <template v-if="item.type === 1">
            <!-- 收益率中可能包含中文, 需要处理成html字段展示-->
            <div
              :class="[item.income === '业绩比较基准' ? 'base-rate' : 'rate-num', 'text-ellipsis']"
              v-html="item.showIncomeRate"
            ></div>
            <div v-if="item.income" class="rate-desc text-ellipsis">{{ item.income }}</div>
          </template>
          <!--  基金 type=4 和  type=2且version=1 都是是基金-->
          <div v-else-if="(item.type === 2 && item.version === 1) || item.type === 4">
            <div class="ipo-fund" v-if="isFirstPublish">首发基金</div>
            <span v-if="newVal?.value">
              <div :class="`rate-num text-ellipsis ${getNumberClassName(newVal.value)}`">
                {{ isCurrency ? changeFundNumber(newVal.value, 4) : changeFundNumber(newVal.value) }}
              </div>
              <div class="rate-desc text-ellipsis">{{ newVal?.name }}</div>
            </span>
          </div>
        </div>
        <div class="product-time-horizon" v-if="!((item.type === 2 && item.version === 1) || item.type === 4)">
          <!-- 投资期限 -->
          <p v-if="item?.investmentHorizon" class="time-horizon text-ellipsis">{{ item.investmentHorizon }}</p>
          <p
            v-if="!item.investmentHorizon && item?.dueTime"
            v-html="item.dueTime"
            class="time-horizon text-ellipsis"
          ></p>
          <!-- 产品标签 起购金额+风险等级 -->
          <p
            v-if="item.leatAmount || (item.risk && item.version === 1) || item.type === 4"
            class="product-tag text-ellipsis"
          >
            {{ `${[item.leatAmount, item.risk].filter(Boolean).join(' | ')}` }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
  import { toRefs, computed } from 'vue';
  import { changeFundNumber, fundInfoFormat, getNumberClassName } from '../../../utils';

  const props = defineProps<{
    item: any;
    firstSelectItem: any;
  }>();

  const { isFirstPublish, isCurrency, newVal } = toRefs(fundInfoFormat(props.item?.fundProductSimpleInfo));

  // 基金类产品且收益率有值|首发基金|价格有值|收益率是中文描述时有值 才展示投资期限
  const isShowTimeHorizon = computed(() => (item: any) => {
    const { type, version, price, showIncomeRate } = item;
    let fundRate = '';
    // 是否为首发基金
    let isIPOFund = false;
    // 基金 type=4 和  type=2且version=1 都是是基金
    const isFund = (type === 2 && version === 1) || type === 4;
    if (isFund) {
      isIPOFund = isFirstPublish.value;
      fundRate = newVal.value?.value as string;
    }
    return (isFund && fundRate) || isIPOFund || price || showIncomeRate;
  });
</script>

<style scoped lang="less">
  // 顶部推荐标签
  .market-top-tag {
    padding: 1px 5px;
    margin-right: 0.1rem;
    font-size: 0.22rem;
    font-weight: normal;
    color: #fff;
    background-color: #ed4444;
    border-radius: 0.08rem 0;
  }
  // 列表项区块
  .market-list-section {
    display: flex;
    flex-direction: column;

    .market-title-row {
      line-height: 0.42rem;
      margin-bottom: 0.1rem;
      // 标题
      .market-row-title {
        line-height: 0.42rem;
        font-size: 0.3rem;
        font-weight: 500;
        color: #333;
        word-break: break-all;
      }
    }
  }

  // 产品列表样式
  .market-product-section {
    width: calc(100% - 0.36rem - 0.3rem);
    font-family: PingFangSC-Regular, 'PingFang SC';
    font-size: 0.24rem;
    font-weight: 400;
    color: #999;

    .product-card-cloumn {
      display: flex;
      justify-content: space-between;

      &-left {
        width: 200px;
      }

      &-right {
        width: 2rem;
        height: 1.5rem;
        border-radius: 3px;
        object-fit: cover;
      }
    }

    .product-card-piccont {
      width: 2rem;
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.8);
      text-align: center;
      border-radius: 3px;

      &.other {
        background-image: url('@shared/assets/images/product/product_bg2.png');
        background-size: 100% 100%;
      }

      &.material {
        background-image: url('@shared/assets/images/product/product_bg1.png');
        background-size: 100% 100%;
      }
    }

    .product-title {
      line-height: 21px;
      font-family: PingFangSC-Semibold, 'PingFang SC';
      font-size: 15px;
      font-weight: 600;
      color: #111;
      word-break: break-all;
    }

    .product-code-type {
      display: flex;
      align-items: baseline;
      margin-top: 0.1rem;

      .product-code {
        max-width: 50%;
        line-height: 18px;
        margin-right: 0.1rem;
        font-family: PingFangSC-Medium, 'PingFang SC';
        font-size: 12px;
        font-weight: 500;
        color: #999;
      }

      .product-type {
        max-width: 50%;
        height: 18px;
        line-height: 18px;
        padding: 0 5px;
        margin-right: 4px;
        font-size: 0.22rem;
        font-size: 11px;
        font-weight: 400;
        color: #fff;
        background: linear-gradient(45deg, #e2b283 0%, #dc954d 100%, #ba8754 100%);
        border-radius: 2px;
      }
    }

    .feature {
      line-height: 17px;
      margin-top: 5px;
      font-family: PingFangSC-Regular, 'PingFang SC';
      font-size: 12px;
      font-weight: 400;
      color: rgba(153, 153, 153, 0.8);
    }

    .ipo-fund {
      height: 0.59rem;
      line-height: 0.59rem;
      margin-top: 0.2rem;
      margin-bottom: 0.09rem;
      font-family: PingFangSC-Semibold, 'PingFang SC';
      font-size: 0.42rem;
      font-weight: 600;
      color: #ff4d4f;
    }

    .product-detail-box {
      display: flex;
      margin-top: 15px;

      .product-rate {
        flex: 0 0 auto;
        width: 50%;

        .rate-num {
          line-height: 30px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-size: 21px;
          font-weight: 500;
          color: #ff4d4f;
        }

        .base-rate {
          line-height: 0.4rem;
          margin-top: 10px;
          font-family: PingFangSC-Medium, 'PingFang SC';
          font-size: 0.28rem;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.88);
        }

        .rate-desc {
          line-height: 17px;
          margin-top: 3px;
          font-family: PingFangSC-Regular, 'PingFang SC';
          font-size: 12px;
          font-weight: 400;
          color: #939495;
          color: rgba(153, 153, 153, 0.8);
        }
      }

      .product-time-horizon {
        flex: 0 0 auto;
        width: 50%;
        padding-left: 0.2rem;

        .time-horizon {
          line-height: 0.4rem;
          margin-top: 10px;
          font-family: PingFangSC-Medium, 'PingFang SC';
          font-size: 0.28rem;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.88);
        }

        .product-tag {
          line-height: 17px;
          margin-top: 3px;
          font-family: PingFangSC-Regular, 'PingFang SC';
          font-size: 12px;
          font-weight: 400;
          color: rgba(153, 153, 153, 0.8);
        }
      }
    }
  }
</style>
